import { el } from "@dhx/ts-common/dom";
import { locale } from "@dhx/ts-diagram";
import { getIcon } from "../../configs/icons";

export class Empty {
	toVDOM(): any {
		return el("div.empty-state", [this._getIcon(), el("span.empty-state__text", locale.emptyState)]);
	}
	private _getIcon(): any {
		return getIcon("empty-icon", "", 29, 29);
	}
}
